export enum Icons {
  LOGO_DARK = '/img/icons/logo/logo-dark.png',
  LOGO_LIGHT = '/img/icons/logo/logo-light.png',
  LOGO_LIGHT_ORIGINAL = '/img/icons/logo/logo-light-original.png',
  TOAST_BLUE = '/img/icons/toast/Blue.png',
  TOAST_GREEN = '/img/icons/toast/Green.png',
  TOAST_RED = '/img/icons/toast/Red.png',
  TOAST_ORANGE = '/img/icons/toast/Orange.png',
  DOWNLOAD = '/img/icons/download.png',
  EYE = '/img/icons/eye.png',
  PDF = '/img/icons/pdf.png',
  HAMBURGER = '/img/icons/hamburger.png',
  ARROW_DOWN = '/img/icons/arrow-down.png',
}